<template>
	<section>
		<load-content v-if="!ready"/>
		<click-option-load-content :labelPath="['datahora']" :list="flatListQuestion" :useSlot="true" :emitEvent="true" :returnProp="'id'">
			<div slot="content">
				<box-title-text v-if="selected" :title="'Enunciado'" :text="selected.valor.enunciado"></box-title-text>
				<click-option-load-content v-if="selected && selected.valor.alternativas" :labelText="'ALTERNATIVA'" :list="flatListAlternatives" :propPath="['valor', 'enunciado']" :id="selected.id"></click-option-load-content>
				<spootlight-info-bar v-if="selected && selected.valor.alternativas"
					:labelText="'Alternativa correta:'"
					:labelColor="'#ffffff'"
					:barColor="'#1a2738'"
					:itemDefaultColor="'#f3f7fc'"
					:spootlightColor="'#eff536'"
					:list="flatListAlternatives"
					:spootIndex="flatListAlternatives.findIndex(a => a.correta)">
				</spootlight-info-bar>
				<box-title-text v-if="selected" :title="'Feedback Positivo'" :text="selected.valor.feedbackPositivo"></box-title-text>
				<box-title-text v-if="selected" :title="'Feedback Negativo'" :text="selected.valor.feedbackNegativo"></box-title-text>
			</div>
		</click-option-load-content>
	</section>
</template>

<script>
import EventBus from '@/components/event-bus.js'
import boxTitleText from '@/components/shared/BoxTitleText'
import clickOptionLoadContent from '@/components/shared/ClickOptionLoadContent'
import spootlightInfoBar from '@/components/shared/SpootlightInfoBar'
import LoadContent from '@/components/shared/LoadContent'
import { questoes } from '@/services/questoes'

export default {
	name: 'historico',
	props: ['question'],
	components: { clickOptionLoadContent, boxTitleText, spootlightInfoBar, LoadContent },
	data () {
		return {
			ready: false,
			path: '',
			history: [],
			selected: undefined
		}
	},
	computed: {
		flatListQuestion: function () {
			return this.history
				.map(h => { return { id: h.id, datahora: h.datahora.toLocaleString('pt-Br', { timeZone: 'UTC' }) } })
		},
		flatListAlternatives: function () {
			return this.selected.valor.alternativas
		}
	},
	watch: {
		history () { this.ready = this.history.length > 0 }
	},
	async created () {
		const resp = await questoes.history(this.$props.question)
		this.history = resp.data
		this.history.forEach(item => {
			item.datahora = new Date(item.datahora)
			item.valor = JSON.parse(item.valor)
		})
		this.history = this.history.sort((curr, next) => curr.datahora - next.datahora)

		EventBus.$on('selectItem', (payLoad) => {
			this.selected = this.history.find(h => h.id === payLoad)
		})
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			vm.path = from.path
		})
	}
}
</script>

<style lang="scss" scoped>

	section{
		background-color: white;
	}

</style>
